/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IAllowance, IAllowanceInterface } from "../IAllowance";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IAllowance__factory {
  static readonly abi = _abi;
  static createInterface(): IAllowanceInterface {
    return new utils.Interface(_abi) as IAllowanceInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IAllowance {
    return new Contract(address, _abi, signerOrProvider) as IAllowance;
  }
}
